<template lang="pug">
    label(
        class="_toggle",
        :class="{ _inv: error }",
        :style="{ width, height }",
        v-on="__on")
        input(
            ref="_in",
            type="checkbox",
            :id="id",
            :name="name",
            :value="val",
            :required="required",
            :disabled="disabled",
            :inert="inert",
            :tabindex="inert ? -1 : tabindex",
            v-on="__on",
            @change="changed")
        span(
            class="_cbc",
            :class="{ ['_'+tone]: tone }",
            aria-hidden="true") &zwnj;
        span(
            v-if="$slots.default",
            class="_cbl")
            slot
</template>

<script>
    import checkbox from './ib-checkbox.vue'

    /**
     * A toggle control that behaves as a checkbox and supports all checkbox v-model behavior.
     */
    export default {
        name: 'ib-toggle',
        mixins: [checkbox]
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._toggle {
        > ._cbc {
            .toggle();
        }
        > input:hover + ._cbc {
            .toggle-hover();
        }
        > input:focus + ._cbc {
            .toggle-focus();
        }
        > input:checked + ._cbc {
            .toggle-checked();
        }
    }

    [dir=ltr] ._toggle,
    [dir=rtl] [dir=ltr] ._toggle {
        > ._cbc {
            .toggle-ltr();
        }
        > input:checked + ._cbc {
            .toggle-ltr-checked();
        }
    }

    [dir=rtl] ._toggle,
    [dir=ltr] [dir=rtl] ._toggle {
        > ._cbc {
            .toggle-rtl();
        }
        > input:checked + ._cbc {
            .toggle-rtl-checked();
        }
    }

    ._cbc {
        &._positive  { color: @fg-positive; }
        &._negative  { color: @fg-negative; }
        &._buy       { color: @fg-buy; }
        &._hold      { color: @fg-hold; }
        &._sell      { color: @fg-sell; }
        &._ok        { color: @fg-ok; }
        &._warning   { color: @fg-warning; }
        &._error     { color: @fg-error; }
    }
</style>

<docs>
    Examples:
    ```jsx
        <ib-context>
            <p><ib-toggle>Basic toggle</ib-toggle></p>
            <p><ib-toggle class="buy">Buy blue toggle</ib-toggle></p>
            <p><ib-toggle disabled="disabled">Disabled toggle</ib-toggle></p>
            <p><ib-toggle inert="inert">Inert toggle</ib-toggle></p>
            <p><ib-toggle class="fs7">Small toggle</ib-toggle></p>
        </ib-context>
    ```
</docs>
